export enum MediaListType {
  Custom = "CUSTOM",
  MyList = "MY_LIST",
  Epg = "EPG"
}
